import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { MessageService, SelectItem, ConfirmationService } from 'primeng/api';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { BusquedadlgComponent } from '../busquedadlg/busquedadlg.component';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { VenenccotizacionService } from "../../ven/venservicios/venenccotizacion.service";
@Component({
  selector: 'app-aggridsacicot',
  templateUrl: './aggridsacicot.component.html',
  styleUrls: ['./aggridsacicot.component.css']
})
export class AggridsacicotComponent implements OnInit, AfterViewInit {
  @Output() selected = new EventEmitter<any>();
  @Output() cellClick = new EventEmitter<any>();
  @Output() rdbtipodet = new EventEmitter<any>();
  @Output() cambios = new EventEmitter<boolean>();

  @ViewChild('gridContainer') gridContainer: ElementRef;

  @Input() width: any;
  @Input() height: string;
  @Input() margintop: string;
  @Input() enableSorting: any;
  @Input() enableFilter: any;
  @Input() comboOpciones: any[];
  @Input() rowData: any[] = [];
  @Input() frameworkComponents: any;
  @Input() animateRows: any;
  @Input() rowSelection: any;
  @Input() columnDefs: any[];
  @Input() defaultColDef: any;
  @Input() rowStyle: any;
  @Input() singleClickEdit: any;
  @Input() botones: any;
  @Input() notlistenkey: boolean;
  @Input() suppressCellSelection: boolean;
  @Input() tipodetalle: string;
  @Input() botonNuevo: boolean;
  @Input() botonGuardar: boolean;
  @Input() botonRegresar: boolean;
  @Input() botonBorrar: boolean;
  style = {};
  public idcell = '';
  public rowcell = '';
  displayDialogBusquedaFast: boolean;


  types: SelectItem[];
  arregloCons: any[];
  opcionbusqueda: string;

  heightguia
  heightguiascrol

  index: number;
  indexunidad: number;
  busquedacampos: string[];
  tabla: string;
  where: string;

  localeText = {
    // Set Filter
    selectAll: '(Seleccionar Todo)',
    selectAllSearchResults: '(Select All Search Results)',
    searchOoo: 'Buscar...',
    blanks: '(En Blanco)',
    noMatches: 'No matches',

    // Number Filter & Text Filter
    filterOoo: 'Filtrar...',
    equals: 'Igual',
    notEqual: 'Diferente',
    empty: 'Choose One',

    // Number Filter
    lessThan: 'Menos que',
    greaterThan: 'Mayor que',
    lessThanOrEqual: 'Menos o igual que',
    greaterThanOrEqual: 'Mayor o igual que',
    inRange: 'En rango de',
    inRangeStart: 'to',
    inRangeEnd: 'from',

    // Text Filter
    contains: 'Contiene',
    notContains: 'No contiene',
    startsWith: 'Empieza con',
    endsWith: 'Termina en',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: 'Y',
    orCondition: 'O',

    // Filter Buttons
    applyFilter: 'Apply',
    resetFilter: 'Reset',
    clearFilter: 'Clear',
    cancelFilter: 'Cancel',

    // Filter Titles
    textFilter: 'Text Filter',
    numberFilter: 'Number Filter',
    dateFilter: 'Date Filter',
    setFilter: 'Set Filter',

    // Side Bar
    columns: 'Columnas',
    filters: 'Filtros',

    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
    values: 'Values',
    valueColumnsEmptyMessage: 'Drag here to aggregate',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',

    // Header of the Default Group Column
    group: 'Group',

    // Other
    loadingOoo: 'Cargando...',
    noRowsToShow: 'No hay filas para mostrar',
    enabled: 'Enabled',

    // Menu
    pinColumn: 'Pin Column',
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'No Pin',
    valueAggregation: 'Value Aggregation',
    autosizeThiscolumn: 'Autosize This Column',
    autosizeAllColumns: 'Autosize All Columns',
    groupBy: 'Group by',
    ungroupBy: 'Un-Group by',
    resetColumns: 'Reset Columns',
    expandAll: 'Expand All',
    collapseAll: 'Close All',
    copy: 'Copy',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copy With Headers',
    paste: 'Paste',
    ctrlV: 'Ctrl+V',
    export: 'Export',
    csvExport: 'CSV Export',
    excelExport: 'Excel Export (.xlsx)',
    excelXmlExport: 'Excel Export (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Sum',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    avg: 'Average',
    filteredRows: 'Filtered',
    selectedRows: 'Selected',
    totalRows: 'Total Rows',
    totalAndFilteredRows: 'Rows',
    more: 'More',
    to: 'to',
    of: 'of',
    page: 'Page',
    nextPage: 'Next Page',
    lastPage: 'Last Page',
    firstPage: 'First Page',
    previousPage: 'Previous Page',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    //top: 'Top',
    //right: 'Right',
    //bottom: 'Bottom',
    //left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',

    // ARIA
    ariaHidden: 'hidden',
    ariaVisible: 'visible',
    ariaChecked: 'checked',
    ariaUnchecked: 'unchecked',
    ariaIndeterminate: 'indeterminate',
    ariaColumnSelectAll: 'Toggle Select All Columns',
    ariaInputEditor: 'Input Editor',
    ariaDateFilterInput: 'Date Filter Input',
    ariaFilterInput: 'Filter Input',
    ariaFilterColumnsInput: 'Filter Columns Input',
    ariaFilterValue: 'Filter Value',
    ariaFilterFromValue: 'Filter from value',
    ariaFilterToValue: 'Filter to value',
    ariaFilteringOperator: 'Filtering Operator',
    ariaColumnToggleVisibility: 'column toggle visibility',
    ariaColumnGroupToggleVisibility: 'column group toggle visibility',
    ariaRowSelect: 'Press SPACE to select this row',
    ariaRowDeselect: 'Press SPACE to deselect this row',
    ariaRowToggleSelection: 'Press Space to toggle row selection',
    ariaRowSelectAll: 'Press Space to toggle all rows selection',
    ariaSearch: 'Search',
    ariaSearchFilterValues: 'Search filter values',
  };

  public gridApi;

  private gridColumnApi;
  consulta: string;
  objetoSeleccionado: any;

  @ViewChild(BusquedadlgComponent) busqF: BusquedadlgComponent;

  constructor(
    private busqService: InvbusquedaService, public init: NuevoComponentService,
    public venenccotizacionService: VenenccotizacionService
  ) { }
  ngAfterViewInit() {
    if (this.gridContainer) {
      //console.log('grid',this.gridContainer.nativeElement)
    }
  }

  ngOnInit(): void {
    this.style = {
      height: 'calc(800px - ' + this.height + 'px)'
      , width: this.width + 'px'
    };
  }
  refreshColumnDefs() {
    //console.log(this.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDef.objeto])
    if (this.gridApi !== undefined) {
      this.gridApi.setColumnDefs(this.columnDefs);
    }
  }
  oncell(event) {
    if (this.gridApi !== null && this.gridApi !== undefined) {
      const rowIndex = event.rowIndex;
      const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
      if (rowNode && !rowNode.isSelected()) {
        // this.gridApi.deselectdAll()
        const selectedNodes = this.gridApi.getSelectedNodes()
        selectedNodes.forEach(element => element.setSelected(false));

        rowNode.setSelected(true)
        //     this.idcell=this.gridApi.getFocusedCell().column.colId;
        // this.rowcell=rowIndex

        this.objetoSeleccionado = this.gridApi.getSelectedRows()[0];
        this.selected.emit({
          object: this.objetoSeleccionado,
          nameobject: this.gridApi.aggFuncService
        });
        this.init.auxsalto = false;
      }



    }
  }

  async onCellKeyDown(e) {
    if (this.notlistenkey === true) {
      return;
    }

    this.cambios.emit(true);
    let gridapi: any;
    let maestro: any;
    let coldef: any;

    if (this.gridApi.getFocusedCell() === null) {
      return;
    }

    if (this.gridApi.getFocusedCell().rowIndex !== false) {
      gridapi = this.gridApi;
      maestro = this.rowData;
      coldef = this.columnDefs;
    }

    if (gridapi === undefined) {
      return;
    }

    let auxiliar = 0;
    if (typeof gridapi.getFocusedCell().column.colDef.editable === 'function') {
      this.gridApi.forEachNode((node) => {
        if (node.selected === true) {
          if (gridapi.getFocusedCell().column.colDef.editable(node) === false) {
            auxiliar++;
          }
        }
      });
    }

    if (auxiliar > 0) {
      return;
    }

    if (e.key !== 'Enter' &&
      e.key !== 'ArrowRight' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowUp' &&
      e.key !== 'ArrowDown' &&
      e.key !== 'Shift' &&
      e.key !== 'Home' &&
      e.key !== 'CapsLock' &&
      e.key !== 'Alt' &&
      e.key !== 'Tab' &&
      e.key !== 'Insert' &&
      e.key !== 'End' &&
      e.key !== 'Backspace' &&
      e.key !== 'PageUp' &&
      e.key !== 'PageDown' &&
      e.key !== 'Control' &&
      e.key !== 'META' &&
      e.key !== 'Meta' &&
      e.key !== 'NUMLOCK' &&
      e.key !== 'F1' &&
      e.key !== 'F2' &&
      e.key !== 'F3' &&
      e.key !== 'F4' &&
      e.key !== 'F5' &&
      e.key !== 'F6' &&
      e.key !== 'F7' &&
      e.key !== 'F8' &&
      e.key !== 'F9' &&
      e.key !== 'F10' &&
      e.key !== 'F11' &&
      e.key !== 'F12' &&
      e.key !== ' ' &&
      e.key !== 'Escape' &&
      e.key !== 'AudioVolumeMute' &&
      e.key !== 'AudioVolumeUp' &&
      e.key !== 'AudioVolumeDown' &&
      e.key !== 'MEDIASTOP' &&
      e.key !== 'MEDIAPLAYPAUSE' &&
      e.key !== 'MEDIATRACKNEXT' &&
      e.key !== 'MEDIATRACKPREVIOUS'
    ) {

      if (this.getParameter(gridapi.getFocusedCell().column.colId, 'numeros', coldef) === false
        && this.getParameter(gridapi.getFocusedCell().column.colId, 'alphabetic', coldef) === false) {
        return;
      }

      if (this.getParameter(gridapi.getFocusedCell().column.colId, 'regexp', coldef) !== undefined) {
        const str = new RegExp(this.getParameter(gridapi.getFocusedCell().column.colId, 'regexp', coldef));
        if (str.test(e.key) === true) {
          maestro[gridapi.getFocusedCell().rowIndex][gridapi.getFocusedCell().column.colId] = e.key;
          //console.log(maestro)
        } else {

          return;
        }
      }
      if (this.getParameter(gridapi.getFocusedCell().column.colId, 'clave', coldef) !== true) {
        if (this.getParameter(gridapi.getFocusedCell().column.colId, 'numeros', coldef) === true
          && this.getParameter(gridapi.getFocusedCell().column.colId, 'alphabetic', coldef) === false) {
          if (/^\d/.test(e.key)) {

            maestro[gridapi.getFocusedCell().rowIndex][gridapi.getFocusedCell().column.colId] = e.key;
            //console.log(maestro)
          }
        } else if (this.getParameter(gridapi.getFocusedCell().column.colId, 'mayusculas', coldef) === true) {
          const key = (e.key + '').toUpperCase();

          maestro[gridapi.getFocusedCell().rowIndex][gridapi.getFocusedCell().column.colId] = key;

        } else {

          maestro[gridapi.getFocusedCell().rowIndex][gridapi.getFocusedCell().column.colId] = e.key;
        }
      }

    }

    if (gridapi.getEditingCells()[0] !== undefined) {
     
      if (gridapi.getEditingCells()[0].column.colId === 'BOD_CODIGO') {
        this.init.auxsalto = false;
      }
      if (gridapi.getEditingCells()[0].column.colId === 'DETCOTIZA_CODIGO') {
        this.init.auxsalto = false;
      }
      if (gridapi.getEditingCells()[0].column.colId === 'PRO_CODIGO') {
        this.init.auxsalto = false;
      }
      

      //CDPJ
    }
    // console.log('gridapi.aggFuncService',gridapi.aggFuncService)
    // console.log('this.init.auxsalto',this.init.auxsalto)
    // console.log('gridapi.getFocusedCell().column.colId',gridapi.getFocusedCell().column.colId)
    // console.log('e.key',e.key)
    if (e.key === 'Enter' &&
      gridapi.getFocusedCell().column.colId === 'BOD_CODIGO' &&
      this.init.auxsalto === false) {
      if (gridapi.aggFuncService === 'detcotiza') {
        this.busquedabodega(maestro[gridapi.getFocusedCell().rowIndex], 'BOD_CODIGO');
      }

    }
    
    if (e.key === 'Enter' &&
      gridapi.getFocusedCell().column.colId === 'DETCOTIZA_CODIGO' && this.init.auxsalto === false) {
        console.log('aqui en el la celda del articulo',gridapi.getFocusedCell().column.colId)
      if (gridapi.aggFuncService === 'detcotiza') {
        if (maestro[gridapi.getFocusedCell().rowIndex].DETCOTIZA_TIPODET === 'A') {

          this.busquedaarticulodetalle(maestro[gridapi.getFocusedCell().rowIndex], 'busquedaarticulo', maestro[gridapi.getFocusedCell().rowIndex].DETCOTIZA_CODIGO);
        }
        if (maestro[gridapi.getFocusedCell().rowIndex].DETCOTIZA_TIPODET === 'S') {
          // this.busquedaserviciodetalle(maestro[gridapi.getFocusedCell().rowIndex], 'busquedaserviciodetfacpro', maestro[gridapi.getFocusedCell().rowIndex].DETFACPRO_CODIGO);
          this.busquedaservicioPedido(maestro[gridapi.getFocusedCell().rowIndex], 'busquedaservicio', maestro[gridapi.getFocusedCell().rowIndex].DETPED_CODIGO);
        }
        if (maestro[gridapi.getFocusedCell().rowIndex].DETCOTIZA_TIPODET === 'I') {
          this.busquedacostosind(maestro[gridapi.getFocusedCell().rowIndex], 'busquedacostosindi');
        }
      }
    }
    if (e.key === 'Enter' &&
      gridapi.getFocusedCell().column.colId === 'PRO_CODIGO') {
      if (gridapi.aggFuncService === 'detcotiza') {
        this.busquedaprove(maestro[gridapi.getFocusedCell().rowIndex], 'PRO_CODIGO');
      }
    }
  }
  busquedaarticulodetalle(rowData, opcionbusqueda, parametro) {
    this.opcionbusqueda = opcionbusqueda;
    switch (opcionbusqueda) {
      case 'busquedaarticulo':
        this.indexunidad = this.gridApi.getFocusedCell().rowIndex;
        break;
      default:
        this.indexunidad = 0;
    }

    this.types = [
      { label: 'Código', value: 'ART_CODIGO' },
      { label: 'Nombre', value: 'ART_NOMBRE' },
      { label: 'Grupo', value: 'GRUP_CODIGO' },
      { label: 'Alias', value: 'ART_NOMBREC' },
      { label: 'Laboratorio', value: 'ART_LABORATORIO' },
      { label: 'Bod-Def', value: 'ART_UBICACION' },
      { label: 'CodigoBarras', value: 'ART_CODIGOALT1' },
      { label: 'Ubicación Física', value: 'ART_CODIGOALT2' },
      { label: 'Alterno3', value: 'ART_CODIGOALT3' },
    ];
    if (parametro === null || parametro === undefined) {
      parametro = '';
    }

    this.busquedacampos = [parametro, '', '', '', '', '', '', '', ''];
    this.consulta = '*';
    this.tabla = 'INV_MAEARTICULO';
    this.where = 'ART_ACTIVO=\'S\' order by 1';

    this.busqService.encontrarRegistro7(parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);

        } else {
          this.abrirDialogBusqueda('*', 'INV_MAEARTICULO', 'rownum <= 100 AND '
            + 'ART_ACTIVO=\'S\'' + ' AND ' + 'UPPER(' + this.types[0].value + ') LIKE UPPER(\'%' + parametro + '%\') order by 1');
        }
      } else {
        this.abrirDialogBusqueda('*', 'INV_MAEARTICULO', 'rownum <= 100 AND '
          + 'ART_ACTIVO=\'S\'' + ' AND '
           + 'UPPER(' + this.types[0].value + ') LIKE UPPER(\'%' + parametro + '%\') order by 1');
      }
    });
  }
  busquedaservicioPedido(rowData, opcionbusqueda, parametro) {
    switch (opcionbusqueda) {

      case 'busquedaservicio':
        this.indexunidad = this.gridApi.getFocusedCell().rowIndex;
        break;
      default:
        this.indexunidad = 0;
    }
    if (parametro === null || parametro === undefined) {
      parametro = '';
    }
    this.opcionbusqueda = opcionbusqueda;

    this.types = [
      { label: 'Código', value: 'SER_CODIGO' },
      { label: 'Descripción', value: 'SER_DESCRIPCION' },
      { label: 'Código Contable', value: 'CON_CODIGO' },
      { label: 'Precio', value: 'SER_PRECIO' },
      { label: 'IVA', value: 'SER_TRIBUTAIVA' }
    ];
    this.busquedacampos = [parametro, '', '', '', ''];
    this.consulta = '*';
    this.tabla = 'VEN_MAESERVICIO';
    this.where = '';

    this.busqService.encontrarRegistro5(parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.abrirDialogBusqueda('*', 'VEN_MAESERVICIO', this.types[0].value + ' LIKE \'%' + parametro + '%\'');
        }
      } else {
        this.abrirDialogBusqueda('*', 'VEN_MAESERVICIO', this.types[0].value + ' LIKE \'%' + parametro + '%\'');
      }
    });

  }
  busquedacostosind(rowData, opcionbusqueda) {
    switch (opcionbusqueda) {

      case 'busquedacostosindi':
        this.indexunidad = this.gridApi.getFocusedCell().rowIndex;
        break;
      default:
        this.indexunidad = 0;
    }
  
    this.opcionbusqueda = opcionbusqueda;
    this.types = [
      { label: 'Código', value: 'CIN_CODIGO' },
      { label: 'Nombre', value: 'CIN_NOMBRE' }
    ];
    this.busquedacampos = ['', ''];
    this.consulta = '*';
    this.tabla = 'PROD_MAECOSTOIND';
    this.where = '';
    this.abrirDialogBusqueda('*', 'PROD_MAECOSTOIND', '');
  }
  busquedaprove(rowData, opcionbusqueda) {
    switch (opcionbusqueda) {
      case 'PRO_CODIGO':
        this.indexunidad = this.gridApi.getFocusedCell().rowIndex;//this.comnotrecServicio.comnotrecImportacionarray[this.init.tabs[this.init.tabindex].indice].findIndex(servicio =>  servicio.LINEA === rowData.LINEA);
        this.where = 'COM_CODIGO = \'01\' and rownum <= 30 ';
        break;
      default:
        this.indexunidad = 0;
    }
    this.opcionbusqueda = opcionbusqueda;
    this.types = [

      { label: 'Código', value: 'PRO_CODIGO' },
      { label: 'Nombre', value: 'PRO_NOMBRE' }
    ];
    this.busquedacampos = ['', ''];
    this.consulta = '*';
    this.tabla = 'COM_MAEPROVEEDOR';

    this.abrirDialogBusqueda('*', 'COM_MAEPROVEEDOR', this.where);
  }
  manejarSeleccion(opcion) {
    this.idcell = '';
    this.rowcell = '';
    const fila = this.rowData[this.indexunidad]
    if (this.opcionbusqueda === 'BOD_CODIGO') {
      fila.BOD_CODIGO = opcion.BOD_CODIGO
      this.rowData = [...this.rowData]
      this.gridApi.refreshCells()
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.indexunidad, 'DETCOTIZA_CODIGO')
      });
    }
    if (this.opcionbusqueda === 'busquedaarticulo') {
      fila.DETCOTIZA_CODIGO = opcion.ART_CODIGO
      fila.DETCOTIZA_DESCRIPCION = opcion.ART_NOMBRE
      fila.DETCOTIZA_UNIDAD = opcion.ART_UNIDADVENTA
      this.rowData = [...this.rowData]
      this.gridApi.refreshCells()
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.indexunidad, 'DETCOTIZA_CANTIDAD')
      });
    }
    if (this.opcionbusqueda === 'busquedaservicio') {
      fila.DETCOTIZA_CODIGO = opcion.SER_CODIGO
      fila.DETCOTIZA_DESCRIPCION = opcion.SER_DESCRIPCION
      this.rowData = [...this.rowData]
      this.gridApi.refreshCells()
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.indexunidad, 'DETCOTIZA_CANTIDAD')
      });
    }
    if (this.opcionbusqueda === 'busquedacostosindi') {
      fila.DETCOTIZA_CODIGO = opcion.CIN_CODIGO
      fila.DETCOTIZA_DESCRIPCION = opcion.CIN_NOMBRE
      this.rowData = [...this.rowData]
      this.gridApi.refreshCells()
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.indexunidad, 'DETCOTIZA_CANTIDAD')
      });
    }
    if (this.opcionbusqueda === 'PRO_CODIGO') {
      fila.PRO_CODIGO = opcion.PRO_CODIGO
      fila.PRO_NOMBRE = opcion.PRO_NOMBRE
      this.rowData = [...this.rowData]
      this.gridApi.refreshCells()
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.indexunidad, 'PRO_NOMBRE')
      });
    }
    
    this.displayDialogBusquedaFast = false
  }
  seleccionrdb(event) {
    this.tipodetalle = event.target.nextSibling.data.replace(' ', '');
    this.rdbtipodet.emit(this.tipodetalle);
  }
  getParameter(campo, parametro, columnDef) {
    for (const u of columnDef) {
      if (u.field === campo) {
        if (u.cellEditorParams !== undefined) {
          if (u.cellEditorParams.values !== undefined) {
            return u.cellEditorParams.values[parametro];
          }
        }
      }
    }
  }
  seleccion(params) {
    // //GSRF
    // this.rolProcesoSrv.numcellnomencrol = this.gridApi.getFocusedCell().rowIndex;
    // this.encfacproService.numcellfacpro = this.gridApi.getFocusedCell().rowIndex;
    // this.encfacproService.idcellfacpro = this.gridApi.getFocusedCell().column.colId;
    // this.comDevFacService.idcelldevfacpro = this.gridApi.getFocusedCell().column.colId;
    // this.venDevFacService.idcelldevfac = this.gridApi.getFocusedCell().rowIndex;
    //  console.log('selecionado--')
    //  console.log('***>local', this.gridApi.getFocusedCell().column.colId )
    //  console.log('***>envia ', this.idcell )
    //  console.log('***>local', this.gridApi.getFocusedCell().rowIndex )
    //  console.log('***>envia ', this.rowcell )
    if (this.idcell === '') {
      this.idcell = this.gridApi.getFocusedCell().column.colId;
    }
    if (this.rowcell === '') {
      this.rowcell = this.gridApi.getFocusedCell().rowIndex;
    }
    //console.log('1',this.gridApi.getFocusedCell().column.colId,'-',this.idcell)
    if (this.gridApi.getFocusedCell().column.colId !== this.idcell) {
      window.alert('Presione enter para terminar edición de la celda1')
      this.gridApi.setFocusedCell(this.rowcell, this.idcell);
      this.gridApi.startEditingCell({ rowIndex: this.rowcell, colKey: this.idcell });
      this.idcell = '';
      this.rowcell = '';
      return;

    }
    //console.log('2',this.gridApi.getFocusedCell().column.rowIndex,'-',this.rowcell)
    if (this.gridApi.getFocusedCell().rowIndex !== this.rowcell) {
      window.alert('Presione enter para terminar edición de la celda2')
      this.gridApi.setFocusedCell(this.rowcell, this.idcell);
      this.gridApi.startEditingCell({ rowIndex: this.rowcell, colKey: this.idcell });
      this.idcell = '';
      this.rowcell = '';
      return;

    }
    this.idcell = '';
    this.rowcell = '';
    //GSRF
    this.objetoSeleccionado = this.gridApi.getSelectedRows()[0];
    this.selected.emit({
      object: this.objetoSeleccionado,
      nameobject: this.gridApi.aggFuncService
    });
    this.init.auxsalto = false;
    this.copytoclipboard(params.event.target.innerHTML);

  }

  copytoclipboard(texto) {

    // if (texto === '' || texto === undefined) {
    //   return;
    // }
    // if (texto.includes('<prueba-cell')) {
    //   return;
    // }

    // navigator.clipboard.writeText(texto).then(() => {
    // }).catch(err => {
    //   console.log('error clipboard', err);
    // })
  }
  enviarSenalGrid(valor) {
    console.log(valor);
    if (this.notlistenkey === true && valor !== 'verInfoArtPed'
      && valor !== 'verInfoArtVeh' && valor !== 'homologaitem') {
      return;
    }
    this.selected.emit(valor);
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.aggFuncService = this.defaultColDef.objeto;
    setTimeout(() => {
      if (this.rowData && this.rowData.length > 0) {
        this.focusUltimaFila();
      }
    })
  }
  focusUltimaFila() {
    if (!this.gridApi || !this.gridColumnApi) {
      return
    }
    const ultimafila = this.rowData.length - 1
    if (ultimafila < 0) {
      return
    }
    const columns = this.gridColumnApi.getAllDisplayedColumns()
    if (!columns || columns.length === 0) {
      return
    }
    const columnId = columns[0].getColId()
    this.gridApi.ensureIndexVisible(ultimafila, 'bottom')
    this.gridApi.forEachNode((node) => {
      if (node.rowIndex === ultimafila) {
        node.setSelected(true)
      }
    })
    this.gridApi.setFocusedCell(ultimafila, columnId)

  }
  
  agregarFila(filaNueva) {
    this.rowData.push(filaNueva)
    this.rowData = [...this.rowData]
    setTimeout(() => {
      this.focusUltimaFila()
    });
  }
  busquedabodega(rowData, opcionbusqueda) {
    switch (opcionbusqueda) {
      case 'BOD_CODIGO':
        this.indexunidad = this.gridApi.getFocusedCell().rowIndex;
        break;
      default:
        this.indexunidad = 0;
    }

    this.opcionbusqueda = opcionbusqueda;
    this.types = [
      { label: 'Código', value: 'BOD_CODIGO' },
      { label: 'Nombre', value: 'BOD_NOMBRE' }
    ];
    this.busquedacampos = [rowData.BOD_CODIGO, ''];
    this.consulta = '*';
    this.tabla = 'INV_MAEBODEGA';
    this.where = '';

    this.busqService.encontrarRegistro15(rowData.BOD_CODIGO).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.abrirDialogBusqueda('*', 'INV_MAEBODEGA', '');
        }
      } else {
        this.abrirDialogBusqueda('*', 'INV_MAEBODEGA', '');
      }
    });
  }

  abrirDialogBusqueda(consulta, tabla, condicion) {
    this.busqService.busquedaTabla(consulta, tabla, condicion).subscribe((datos: any[]) => {
      this.arregloCons = datos;
      if (this.opcionbusqueda === 'busquedaGuiapet') {
        this.heightguia = '390px'
        this.heightguiascrol = '290px';
      } else {
        if (this.opcionbusqueda === 'busquedaGuia') {
          this.heightguia = '390px'
          this.heightguiascrol = '290px';
        } else {
          this.heightguia = '280px'
          this.heightguiascrol = '200px'
        }
        this.displayDialogBusquedaFast = true;
      }
    });
  }
  onshowbusqF() {
    this.busqF.prueba();
  }
}
